import { useState, useMemo } from 'react'
import { components } from 'react-select'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import moment from 'moment'

import { stockAccolades } from '../../accolades/accolades'
import Select from '../common/form/Select'
import Input from '../common/form/Input'

import classes from './AccoladeSelect.module.scss'

const AccoladeSelect = ({ allAccolades, currentAccolades, onAddAccolade }) => {
  const { t } = useTranslation()
  const [changeDate, setChangeDate] = useState(moment())

  const availableOptions = useMemo(() => {
    const currentAccoladeIds = currentAccolades.map(acc => acc.accolade?.id || acc.accolade_id)
    return allAccolades.filter(acc => !currentAccoladeIds.includes(acc.id))
  }, [allAccolades, currentAccolades])

  const handleSelectAccolade = (option) => {
    if (option) {
      onAddAccolade({
        accolade_id: option.id,
        issued_date: changeDate.format('YYYY-MM-DD'),
      })
    }
  }

  /* eslint-disable react/prop-types */
  const Option = ({ data, ...props }) => {
    const accoladeBadge = stockAccolades[data.name]?.badge

    return (
      <components.Option {...props}>
        <div className={classes.optionContainer}>
          <div className={classes.accoladeInfo}>
            {accoladeBadge && (
              <div
                className={classes.accoladeBadge}
                style={{ backgroundImage: `url(${accoladeBadge})` }}
              />
            )}
            <span className={classes.accoladeName}>{data.name}</span>
          </div>
        </div>
      </components.Option>
    )
  }
  /* eslint-enable react/prop-types */

  return (
    <div>
      <div className='mb-3'>
        <label htmlFor='accolade-selector'>{t('coaches.accoladeSelect.selectAccolade')}</label>
        <Select
          name='accolade-selector'
          noOptionsMessage={() => t('common.noOptions')}
          value={null}
          options={availableOptions}
          components={{ Option }}
          onChange={handleSelectAccolade}
          placeholder={t('coaches.accoladeSelect.selectAccolade')}
          isSearchable={false}
          menuPlacement='auto'
          minMenuHeight={300}
          menuPosition='fixed'
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
        />
      </div>

      <div>
        <label htmlFor='issued_date'>{t('coaches.accoladeSelect.changeDate')}</label>
        <Input
          type='date'
          name='issued_date'
          selected={changeDate}
          onChange={setChangeDate}
          maxDate={moment()}
          dateFormat='MM/dd/yyyy'
          placeholderText='MM/DD/YYYY'
        />
      </div>
    </div>
  )
}

AccoladeSelect.propTypes = {
  allAccolades: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  currentAccolades: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    accolade_id: PropTypes.number,
    accolade: PropTypes.shape({ id: PropTypes.number }),
  })),
  onAddAccolade: PropTypes.func.isRequired,
}

export default AccoladeSelect
